export default __webpack_public_path__ + "static/media/HighlightBox1_1.0c68f008.svg";